import React from "react";
import ContactSection from "./ContactSection";
import Carousel from "./Carousel";
import { useNavigate } from "react-router-dom";

const MainContent = () => {
  const navigate = useNavigate();

  return (
    <main className="main-content">
      <section className="content-section">
        <h1>Expand your mind and start your journey through books</h1>
        <div className="info">
          <div className="info1">
            <img src="../images/logo3.webp" alt="" />
            <p>
              Our book website offers seamless navigation, allowing you to
              effortlessly explore a vast array of authors and genres. whether
              you're searching for a classic masterpiece or the latest
              bestseller, finding your next read has never been easier
            </p>
          </div>
          <div className="info2">
            <img src="../images/logo1.webp" alt="" />
            <p>
              With intuitive filtering options, you can tailor your search to
              your preferences, refining results by author, genre, or
              publication date. discovering new literary gems has never been
              more convenient
            </p>
          </div>
          <div className="info3">
            <img src="../images/logo2.webp" alt="" />
            <p>
              Need assistance? our dedicated support team is here to provide
              expert guidance and recommendations. from navigating the site to
              resolving queries, we ensure a smooth and enjoyable browsing
              experience for all book enthusiasts
            </p>
          </div>
        </div>
        <button onClick={() => navigate("/books")} className="more-info-button">
          MORE INFO
        </button>
        <Carousel />
      </section>
      <ContactSection />
    </main>
  );
};

export default MainContent;
